export const TEXTS = {
  verifyingTitle: 'Verifying email...',
  verifyingDescription: 'Please wait while we validate your link.',
  resetPasswordTitle: 'Reset Password',
  resetPasswordDescription: 'Enter your new password',
};
